import { Tabs } from 'Components';
import i18n from 'i18next';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import React, { Fragment } from 'react';
import './HeadDesktop.css';

const HeadDesktop = ({
  isGlobalSearch,
  hideTabs,
  handleClick,
  tabs,
  headIndex,
  headTitle,
  headSubTitle,
  headDescription,
}) => {
  return (
    <Fragment>
      <div className="head__desktop">
        <div className="head__desktop__content">
          <h1 className={classNames('head__desktop__content__header', { 'head__desktop__content__header--small': (headTitle || '').length > 100 })}>
            {headTitle} { headSubTitle && <span>{headSubTitle}</span> }
          </h1>
          {headDescription && <span>{headDescription}</span>}
          { (!hideTabs && !isGlobalSearch) &&
          <Fragment>
            <Tabs
              onClick={handleClick}
              tabs={tabs}
              labels={tabs.map(tab => i18n.t(`head:${tab}`))}
              index={headIndex}
              className="tabs__underline"
            />
          </Fragment>}
        </div>
        <hr className="head_desktop__content__bar" />
      </div>
    </Fragment>
  );
};
HeadDesktop.propTypes = {
  isGlobalSearch: PropTypes.bool,
  meta: PropTypes.shape({}),
  hideTabs: PropTypes.bool,
  handleClick: PropTypes.func,
  tabs: PropTypes.arrayOf(PropTypes.string),
  headIndex: PropTypes.number,
  headTitle: PropTypes.string,
  headSubTitle: PropTypes.string,
  headDescription: PropTypes.string,
};

HeadDesktop.defaultProps = {
  headTitle: '',
};

export default HeadDesktop;



// WEBPACK FOOTER //
// ./src/containers/Head/HeadDesktop/HeadDesktop.jsx